import cls from "classnames";
import mapboxgl from "mapbox-gl";
import { useEffect } from "react";
import { nodeResizeEvent } from "imagica-corekit/dist/base/api/mapTyped/Map";
import styles from "./MapView.module.scss";
import { MapViewBloc } from "./MapViewBloc";
import { isEmpty } from "lodash";
import { CanvasView } from "./views/CanvasView";
import { PreviewView } from "./views/PreviewView";
import { Spin } from "antd";
import store from "../../../../store";
import { useDidMount } from "imagica-uikit/dist/hooks/useDidMount";

export const initialMapSize = {
  width: 300,
  height: 600,
};

type TextAreaValue = {
  date: number;
  value: string;
};

type MapViewProps = {
  id: string;
  isShare: boolean;
  isOpenDeleteBox: boolean;
  displayLabel: boolean;
  bloc: MapViewBloc;
  resizeEventParams: nodeResizeEvent;
  textAreaValue: TextAreaValue | string;
  noWheelClassName: string;
  errorText: string;
};

export function MapView(props: MapViewProps) {
  const { id, bloc, isShare, textAreaValue, resizeEventParams, noWheelClassName, errorText } = props;

  const { width = initialMapSize.width, height = initialMapSize.height } = resizeEventParams || {};
  // const isMobile = window.navigator.userAgent.includes("Mobile");

  useEffect(() => {
    if (bloc.map.value) {
      bloc.map.value.resize();
    }
  }, [width, height]);

  useEffect(() => {
    if (isEmpty(textAreaValue)) {
      return;
    }
    if (bloc.isFirstLoad.value) {
      return;
    }
    const inputTxt = typeof textAreaValue === "string" ? textAreaValue : textAreaValue?.value;
    bloc.reloadMap(inputTxt);
  }, [store.getState().editor.reloadMap, textAreaValue]);

  useDidMount(() => {
    // 如果是取消接口请求，不重新执行init
    if (errorText && errorText.includes("aborted")) return;
    const inputTxt = typeof textAreaValue === "string" ? textAreaValue : textAreaValue?.value;
    bloc.init(id, inputTxt);
  });
  const innerClassName = cls(styles.mapBoxInner, "nodrag", "nowheel");
  return (
    <div className={styles.mapBoxInner} style={id.includes("preview") ? {} : { width, height, overflow: "hidden" }}>
      <Spin tip="Loading" size="large" spinning={props.bloc.mapLoading.value}>
        {/* {isShare && !isMobile ? (
        <ShareView id={id} bloc={bloc} width={width} height={height} />
      ) :  */}
        {id.includes("preview") || isShare ? (
          <PreviewView noWheelClassName={noWheelClassName} id={id} bloc={bloc} height={height} />
        ) : (
          <CanvasView noWheelClassName={noWheelClassName} id={id} bloc={bloc} height={height} />
        )}
      </Spin>
    </div>
  );
}

export const MapNodeWithBloc: React.FC<MapViewProps> = props => {
  return <MapView {...props} bloc={new MapViewBloc(mapboxgl)} />;
};
